const normalize = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

const lifecycle = (overrides) => ({
  actionRequired: false,
  formed: false,
  terminal: false,
  tone: 'info',
  ...overrides,
});

const STAGES = {
  completed: lifecycle({
    id: 'active',
    labelKey: 'empresas.stages.incorporated',
    formed: true,
    tone: 'success',
  }),
  delivered: lifecycle({
    id: 'active',
    labelKey: 'empresas.stages.incorporated',
    formed: true,
    tone: 'success',
  }),
  filed: lifecycle({
    id: 'filed',
    labelKey: 'empresas.stages.filed',
  }),
  filing: lifecycle({
    id: 'filing',
    labelKey: 'empresas.stages.inFormation',
    tone: 'attention',
  }),
  formation: lifecycle({
    id: 'filing',
    labelKey: 'empresas.stages.inFormation',
    tone: 'attention',
  }),
  formation_processing: lifecycle({
    id: 'filing',
    labelKey: 'empresas.stages.processing',
  }),
  details_pending: lifecycle({
    id: 'details_pending',
    labelKey: 'empresas.stages.detailsPending',
  }),
  under_review: lifecycle({
    id: 'under_review',
    labelKey: 'empresas.stages.underReview',
  }),
  approved: lifecycle({
    id: 'approved',
    labelKey: 'import.statusSection.status.approved',
    tone: 'success',
  }),
  payment_completed: lifecycle({
    id: 'payment_completed',
    labelKey: 'empresas.stages.paymentCompleted',
  }),
  payment_processing: lifecycle({
    id: 'payment_processing',
    labelKey: 'empresas.stages.processingPayment',
  }),
  payment: lifecycle({
    id: 'payment_pending',
    labelKey: 'empresas.stages.paymentPending',
    actionRequired: true,
    tone: 'attention',
  }),
  payment_pending: lifecycle({
    id: 'payment_pending',
    labelKey: 'empresas.stages.paymentPending',
    actionRequired: true,
    tone: 'attention',
  }),
  initial: lifecycle({
    id: 'details_pending',
    labelKey: 'empresas.stages.basicData',
    actionRequired: true,
    tone: 'attention',
  }),
  data_collection: lifecycle({
    id: 'details_pending',
    labelKey: 'empresas.stages.partnersData',
    actionRequired: true,
    tone: 'attention',
  }),
  plan_selection: lifecycle({
    id: 'details_pending',
    labelKey: 'empresas.stages.selectPlan',
    actionRequired: true,
    tone: 'attention',
  }),
};

const FALLBACK = lifecycle({
  id: 'in_process',
  labelKey: 'empresas.stages.inProcess',
  tone: 'neutral',
});

export function resolveCompanyLifecycle(company) {
  const companyRecord = company || {};
  const dissolutionStatus = normalize(
    companyRecord.dissolutionStatus ??
      companyRecord.dissolution_status ??
      companyRecord._raw?.dissolutionStatus ??
      companyRecord._raw?.dissolution_status
  );

  if (dissolutionStatus === 'completed') {
    return lifecycle({
      id: 'dissolved',
      labelKey: 'empresas.stages.dissolved',
      terminal: true,
      tone: 'neutral',
    });
  }

  const stage = normalize(
    companyRecord.currentStage ??
      companyRecord.current_stage ??
      companyRecord.status
  );
  return STAGES[stage] || FALLBACK;
}
